module.exports = __webpack_public_path__ + "f7b2966b4b91b06016982dbe85650613.jpg";